export const environment = {
  appname: 'Pink Soul',
  host: 'https://pinksoul.us',
  api: {
    host: 'https://pinksoul.us/api',
    s3endpoint: 'https://storage.pinksoul.us',
  },
  google: {
    reCaptcha: {
      siteKey: '6Ldyao4rAAAAADW7l9IKQWUvqUX3vZgGEXusC8hd',
    },
    oauth: {
      clientID:
        '642873476515-p9srk1f1td6odi68mso7rusosuqbgfnk.apps.googleusercontent.com',
    },
    api: {
      place: 'AIzaSyCL2N48eT0s1oeO4d5SKi3WBTLUlvEtKXM',
    },
  },
  stripe: {
    apikey:
      'pk_live_51RZpZYAcHBkLHzOruLJFVePZ4VwKRyaLLYhRuEwnZ553sqmFKP7qHaQCmVrwXPJGAa6EJe3t2DhBEWvdcbhPkhcI00v3GMHJug',
  },
};
